import styled from '../../styled-components';

export const InlineP = styled.p`
    display: inline-block;
    margin: 0;
`;
